import React, { Component } from 'react';
import __ from 'lodash';
import history from '../../../../history';
import { URL_AKM,CONFIG_API_BE } from '../../../../config';
import akmApi from '../../../../apis/akmApi';
import eduprimeApi from '../../../../apis/eduprimeApi';
import {Row, Col} from 'react-bootstrap';
import Alert from '@material-ui/lab/Alert';
import IconButton from '@material-ui/core/IconButton';
import Collapse from '@material-ui/core/Collapse';
import Button from '@material-ui/core/Button';
import CloseIcon from '@material-ui/icons/Close';
import { FormControl, FormHelperText, Input, InputLabel } from '@material-ui/core';
import Select from 'react-select';
import LoaderModal from '../../../modal/LoaderModal';

class AccountForm extends Component {
    constructor(props) {
        super(props);
        const routeState = (props.location && props.location.state) || {};
        this.state = { 
            isFetching: false,
            isLoading: false,
            showAlert: false,
            alertMessage: "Error...",
            modalForm: false,
            admin: {...(routeState.admin || {}), passwordAdmin: ""},
            hasFormContext: !!routeState.admin,
            confirmPassword: "",
            dinasPemda: {},
            dinasDetail: [],
            selectedProvinsi: null,
            selectedKab: null,
            selectedJenjang: null,
            kabupaten: [],
            savedRegionJenjang: {},
            hasMixedRegionJenjang: false,
            regionJenjangChanged: false,
            regionReviewRequired: false
        }
    }

    async componentDidMount() {
        const {admin} = this.state;
        
        if(!__.isUndefined(admin.idAdmin)) {
            if(admin.idRole === 12 && admin.idDinasPemda !== null) {
                this.fecthDinasPemda(admin.idDinasPemda);
            }
        }
        this.hiddenNavbar = document.getElementsByClassName('navbar')[0];
        if (this.hiddenNavbar) {
            this.previousNavbarVisibility = this.hiddenNavbar.style.visibility;
            this.hiddenNavbar.style.visibility = 'hidden';
        }
    }

    componentWillUnmount() {
        if (this.hiddenNavbar) this.hiddenNavbar.style.visibility = this.previousNavbarVisibility;
    }

    fecthDinasPemda = async(idDinasPemda) => {
        this.setState({isFetching: true})
        try {
        const response = await akmApi.get(URL_AKM.DINAS_PEMDA_GET_BY_ID,
            {params: { idDinasPemda : idDinasPemda }});
        if(response){           
            if(response.data.errorSchema.errorCode === URL_AKM.SUCCESS_ERROR_CODE){
                const prov = this.props.location.state.provinsi.find(p => p.value == response.data.data.idProvinsi)
                if (!prov) throw new Error('Provinsi belum tersedia');
                this.setState({ selectedProvinsi: { value: prov.value, label: prov.label} })
                const citiesReady = await this.fetchKabupaten(prov.value);
                if (!citiesReady) return;
                const {level} = this.props.match.params;
                if(level === 'DINDIK') {
                    await this.fecthDinasDetails(idDinasPemda);
                } 
                if(level === 'DINAS') {
                    const kab = this.state.kabupaten.find(item => item.value == response.data.data.idKabupatenKota);
                    this.setState({selectedKab:kab || null});
                }
            }            
        }
        } catch (error) {
            this.setState({showAlert:true, alertMessage:'Data wilayah dinas belum dapat dimuat. Silakan buka kembali formulir.'});
        } finally {
            this.setState({isFetching:false});
        }
    }

    fecthDinasDetails = async(idDinasPemda) => {
        this.setState({isFetching: true})
        const response = await akmApi.get(URL_AKM.DINAS_DETAIL_GET_BY_ID_DINAS,
            {params: { idDinasPemda : idDinasPemda }});
        if(response){           
            if(response.data.errorSchema.errorCode === URL_AKM.SUCCESS_ERROR_CODE){                
                const saved = {}, cities = [], codeSets = new Set();
                let reviewRequired = false;
                response.data.data.forEach(row => {
                    const key = String(row.idKabupatenKota);
                    const code = typeof row.kodeJenjangSekolah === 'string' ? row.kodeJenjangSekolah : '';
                    const normalized = code.split(',').map(value => value.trim()).filter(Boolean).sort().join(',');
                    if (!normalized || (saved[key] !== undefined && saved[key] !== code)) reviewRequired = true;
                    if (saved[key] === undefined) {
                        const city = this.state.kabupaten.find(item => String(item.value) === key);
                        cities.push(city || {value:row.idKabupatenKota, label:'Wilayah ' + key});
                    }
                    saved[key] = code;
                    codeSets.add(normalized);
                });
                const mixed = codeSets.size > 1;
                const common = !mixed && !reviewRequired && codeSets.size ? [...codeSets][0].split(',').map(value => ({value, label:value})) : null;
                this.setState({selectedKab:cities, selectedJenjang:common, savedRegionJenjang:saved, hasMixedRegionJenjang:mixed, regionJenjangChanged:false, regionReviewRequired:reviewRequired});
            }            
            this.setState({isFetching: false})
        }
    }

    fetchKabupaten = async(idProvinsi) => {
        const request = this.cityRequest = (this.cityRequest || 0) + 1;
        this.setState({isLoading: true, kabupaten: [], selectedKab: null})
        try {
        const response = await eduprimeApi.get(CONFIG_API_BE.API_GET_KAB_KOTA + idProvinsi);
        if (request !== this.cityRequest) return false;
        if (!response || response.status !== 200 || !response.data || !Array.isArray(response.data.list_kab_kota)) throw new Error('Kabupaten belum tersedia');
        if(response){
            let data = [];
            if(response.status === 200){
                response.data.list_kab_kota.map(value => {
                    const object = {
                        'value': value.ID_KABUPATEN_KOTA,
                        'label': value.NAMA_KABUPATEN_KOTA
                    }
                    data.push(object)
                })
            }            
            this.setState({ kabupaten: data, isLoading: false})
        }
        return true;
        } catch (error) {
            if (request === this.cityRequest) this.setState({showAlert:true, alertMessage:'Daftar kabupaten belum dapat dimuat. Pilih kembali provinsi untuk mencoba lagi.'});
            return false;
        } finally {
            if (request === this.cityRequest) this.setState({isLoading:false});
        }
    }

    handleSubmit = async(e) => {
        e.preventDefault();
        let {admin, selectedProvinsi, selectedKab, selectedJenjang} = this.state;
        const {idRole,level} = this.props.match.params;
        if (!this.state.hasFormContext) return false;
        if(admin.namaAdminUser === undefined || admin.namaAdminUser === '') return false;
        if(admin.usernameAdmin === undefined || admin.usernameAdmin === '') return false;
        const isExisting = admin.idAdmin !== undefined && admin.idAdmin !== null;
        const password = admin.passwordAdmin || "";
        if ((!isExisting && password === "") || (password !== "" && password !== this.state.confirmPassword)) return false;
        if (password === "" && this.state.confirmPassword !== "") return false;
        if (selectedProvinsi === null || (level !== 'DINDIK' && selectedKab === null)) return false;
        if(level === 'DINDIK') {
            if(!Array.isArray(selectedKab) || selectedKab.length === 0) return false;
            const hasCommon = Array.isArray(selectedJenjang) && selectedJenjang.length > 0;
            const canPreserve = !this.state.regionJenjangChanged && !this.state.regionReviewRequired && selectedKab.every(item => !!this.state.savedRegionJenjang[String(item.value)]);
            if (!hasCommon && !canPreserve) return false;
            if (this.state.regionReviewRequired && !this.state.regionJenjangChanged) return false;
        }
       
        admin = {...admin, 
            levelAdminUser: level,
            statusAdminUser: 1,
            idRole: idRole,
            kodeOwner: 'PRIME',
            kodeCabangPrime: 'HO'
        }
        if (isExisting && password === "") delete admin.passwordAdmin;
        
        let dinasPemda = {
            idProvinsi: selectedProvinsi === null ? null : selectedProvinsi.value,
            idKabupatenKota: level === 'DINDIK' ? null : selectedKab.value,
            namaDinas: admin.namaAdminUser
        }
        if (admin.idDinasPemda !== null && admin.idDinasPemda !== undefined) {
            dinasPemda.idDinasPemda = admin.idDinasPemda;
        }

        return this.postData(dinasPemda, admin, level, selectedKab, selectedJenjang);

    }

    handleBack() {
        history.push({
            pathname: '/mgtakun',
            state: {
                role: this.props.location.state && this.props.location.state.role
            }
        })
    }

    postData = async(dinasPemda, admin, level, selectedKab, selectedJenjang) => {
        if (this.state.isFetching) return;
        this.setState({isFetching: true, showAlert: false});
        const accepted = response => response && response.data && response.data.errorSchema && response.data.errorSchema.errorCode === URL_AKM.SUCCESS_ERROR_CODE;
        let stage = 'data dinas';
        try {
            const saveDinas = await akmApi.post(URL_AKM.POST_DINAS_PEMDA_SAVE, dinasPemda);
            if (!accepted(saveDinas) || !saveDinas.data.data) throw new Error('Dinas belum tersimpan');
            const idDinas = saveDinas.data.data.idDinasPemda;
            if (!Number.isSafeInteger(Number(idDinas)) || Number(idDinas) <= 0) throw new Error('Identitas dinas tidak tersedia');
            this.setState({admin:{...this.state.admin, idDinasPemda:idDinas}});
            if(level === 'DINDIK') {
                stage = 'wilayah dinas';
                const jenjang = (selectedJenjang || []).map(item => item.value).join(',');
                const dinasDetail = selectedKab.map(item => ({idKabupatenKota:item.value, kodeJenjangSekolah:!this.state.regionJenjangChanged && this.state.savedRegionJenjang[String(item.value)] ? this.state.savedRegionJenjang[String(item.value)] : jenjang, idDinasPemda:idDinas}));
                const saveRegions = await akmApi.put(URL_AKM.DINAS_DETAIL_GET_BY_ID_DINAS + '/' + encodeURIComponent(idDinas), dinasDetail);
                if (!accepted(saveRegions)) throw new Error('Wilayah belum tersimpan');
            }
            stage = 'akun';
            const saveAdmin = await akmApi.post(URL_AKM.POST_SAVE_ADMIN, {...admin, idDinasPemda:idDinas});
            if (!accepted(saveAdmin)) throw new Error('Akun belum tersimpan');
            this.handleBack();
        } catch (error) {
            this.setState({showAlert:true, alertMessage:'Penyimpanan ' + stage + ' belum dapat dikonfirmasi. Periksa data sebelum mencoba lagi.'});
        } finally {
            this.setState({isFetching:false});
        }
    }

    onChangeNama = (event) => { 
        this.setState({ admin: {...this.state.admin, namaAdminUser: event.target.value} }) 
    }
    onChangeUsername = (event) => {
        this.setState({ admin: {...this.state.admin, usernameAdmin: event.target.value} }) 
    }
    onChangePassword = (event) => {
        this.setState({ admin: {...this.state.admin, passwordAdmin: event.target.value} }) 
    }
    onChangePassword2 = (event) => {
        this.setState({ confirmPassword: event.target.value }) 
    }
    onChangeTelepon = (event) => {
        this.setState({ admin: {...this.state.admin, telponAdmin: event.target.value} })  
    }
    onChangeEmail = (event) => {
        this.setState({ admin: {...this.state.admin, emailAdminUser: event.target.value} })  
    }
    handleChangeProvinsi = (data) => {
        this.setState({selectedProvinsi: data})
        this.fetchKabupaten(data.value)
    }
    handleChangeKabupaten = (data) => {
        this.setState({selectedKab: data})
    }
    handleChangeJenjang = (data) => {
        this.setState({selectedJenjang:data, regionJenjangChanged:true})
    }

    render() {
        const {admin} = this.state;
        const {idRole, level} = this.props.match.params;
        const isExisting = admin.idAdmin !== undefined && admin.idAdmin !== null;
        const needsPassword = !isExisting || admin.passwordAdmin !== "";
        if (!this.state.hasFormContext) return <div className="container" role="alert">
            <p>Buka formulir melalui Manajemen Akun agar akun yang diubah jelas.</p>
            <Button variant="outlined" onClick={() => this.handleBack()}>Kembali ke Manajemen Akun</Button>
        </div>;

        return(
            <div className="">
                <LoaderModal isFetching={this.state.isFetching}/> 
                
                <div className="container" style={{paddingBottom: '50px', paddingTop:'20px'}}>
                    

                    <Row>
                        <Col sm={8}>
                            <h2>Management Akun User {level}</h2>
                        </Col>
                       
                        <Col>
                            <Button className="pull-right" variant="outlined" color="secondary" onClick={() => {if (window.confirm('Konfirmasi Keluar ?')) this.handleBack()}}>
                                Batal &nbsp;<i className="fa fa-arrow-right"></i></Button>                                     
                        </Col>
                    </Row>
                   
                    {this.handleAlert()}

                    {idRole === "12" ?
                    <form noValidate onSubmit={this.handleSubmit}>     
                        <FormControl>
                            <InputLabel htmlFor="nama">Nama*</InputLabel>
                            <Input
                                error={admin.namaAdminUser === undefined || admin.namaAdminUser === "" ? true : false}
                                id="nama"
                                defaultValue={admin.namaAdminUser} 
                                onChange={this.onChangeNama}
                                required
                            />
                            {(admin.namaAdminUser === undefined || admin.namaAdminUser === "") &&
                            <FormHelperText className="text-danger">Incorrect entry...</FormHelperText>}
                        </FormControl> 

                        <FormControl>
                            <InputLabel htmlFor="username">Username*</InputLabel>
                            <Input
                                error={admin.usernameAdmin === undefined || admin.usernameAdmin === "" ? true : false}
                                id="username"
                                autoSave="false"
                                defaultValue={admin.usernameAdmin} 
                                onChange={this.onChangeUsername}
                                required
                            />
                            {(admin.usernameAdmin === undefined || admin.usernameAdmin === "") &&
                            <FormHelperText className="text-danger">Incorrect entry...</FormHelperText>}
                        </FormControl> 

                        <FormControl>
                            <InputLabel htmlFor="password">{isExisting ? "Password baru" : "Password*"}</InputLabel>
                            <Input
                                error={needsPassword && admin.passwordAdmin === ""}
                                autoComplete="new-password"
                                autoSave="false"
                                type="password"
                                id="password"
                                value={admin.passwordAdmin}
                                onChange={this.onChangePassword}
                                required={!isExisting}
                            />
                            {isExisting && <FormHelperText>Kosongkan untuk mempertahankan password saat ini.</FormHelperText>}
                            {!isExisting && admin.passwordAdmin === "" &&
                            <FormHelperText className="text-danger">Password wajib diisi.</FormHelperText>}
                        </FormControl> 

                        <FormControl>
                            <InputLabel htmlFor="password2">{needsPassword ? "Konfirmasi password*" : "Konfirmasi password"}</InputLabel>
                            <Input 
                                error={this.state.confirmPassword !== admin.passwordAdmin}
                                type="password"
                                id="password2"
                                defaultValue={this.state.confirmPassword} 
                                onChange={this.onChangePassword2}
                                required={needsPassword}
                            />
                            {( this.state.confirmPassword !== admin.passwordAdmin) &&
                            <FormHelperText className="text-danger">Password did not matched...</FormHelperText>}
                        </FormControl>                     
                        
                        <FormControl>
                            <InputLabel htmlFor="telepon">No. Telepon</InputLabel>
                            <Input
                                type="number"
                                id="telepon"
                                defaultValue={admin.telponAdmin} 
                                onChange={this.onChangeTelepon}                                
                            />                            
                        </FormControl> 

                        <FormControl>
                            <InputLabel htmlFor="email">Email</InputLabel>
                            <Input
                                type="email"
                                id="email"
                                defaultValue={admin.emailAdminUser} 
                                onChange={this.onChangeEmail}                                
                            />                            
                        </FormControl>   

                        <FormControl style={{marginTop: '15px'}}>  
                        <Row>
                            <Col>
                                <Select
                                    className="basic-single"
                                    placeholder ="Pilih Provinsi..."
                                    classNamePrefix="select"
                                    value={this.state.selectedProvinsi}
                                    isSearchable={true}
                                    name="provinsi"
                                    options={this.props.location.state.provinsi}
                                    onChange={this.handleChangeProvinsi}
                                /> 
                                {this.state.selectedProvinsi === null &&     
                                <FormHelperText className="text-danger">Incorrect entry...</FormHelperText> }
                            </Col>

                            <Col>
                                <Select isMulti={level === 'DINDIK' ? true : false}
                                    className="basic-single"
                                    placeholder ="Pilih Kabupaten..."
                                    classNamePrefix="select"
                                    value={this.state.selectedKab}
                                    isLoading={this.state.isLoading}
                                    isSearchable={true}
                                    name="provinsi"
                                    options={this.state.kabupaten}
                                    onChange={this.handleChangeKabupaten}
                                />  
                                {this.state.selectedKab === null &&     
                                <FormHelperText className="text-danger">Incorrect entry...</FormHelperText> }
                            </Col>
                        </Row>                   
                        </FormControl>    

                        {level === 'DINDIK' && <FormControl style={{marginTop: '15px'}}>  
                        <Row>
                            <Col sm={6}>
                                <Select isMulti
                                    className="basic-single"
                                    placeholder ="Pilih Jenjang..."
                                    classNamePrefix="select"
                                    value={this.state.selectedJenjang}
                                    isSearchable={true}
                                    name="jenjang"
                                    options={this.props.location.state.kodeJenjang}
                                    onChange={this.handleChangeJenjang}
                                />  
                                {(this.state.hasMixedRegionJenjang || this.state.regionReviewRequired) &&
                                <FormHelperText>Jenjang berbeda per wilayah. Tanpa pilihan baru, jenjang lama tiap wilayah dipertahankan. Pilihan baru berlaku untuk semua wilayah.</FormHelperText>}
                                {this.state.regionReviewRequired && !this.state.regionJenjangChanged &&
                                <FormHelperText className="text-danger">Data jenjang lama perlu diperiksa. Pilih jenjang yang disetujui sebelum menyimpan.</FormHelperText>}
                                {this.state.selectedJenjang === null && !this.state.hasMixedRegionJenjang &&
                                <FormHelperText className="text-danger">Incorrect entry...</FormHelperText> }
                            
                            </Col>
                        </Row>
                        </FormControl>  }                  

                        <FormControl style={{marginTop: '30px'}}> 
                            <Button variant="outlined" type="submit" color="primary">Simpan</Button>
                        </FormControl>
                        
                    </form>
                    :
                    <h2 className="text-warning">On Progress gaes... Sabar dulu</h2>
                    }
                </div>
            </div>
        )
    }

    handleAlert() {
        return(
            <Collapse in={this.state.showAlert} style={{marginBottom: '13px'}}>
                <Alert severity="error"
                    action={
                    <IconButton
                        aria-label="close"
                        color="inherit"
                        size="small"
                        onClick={() => this.setState({showAlert: false})}
                    >
                        <CloseIcon fontSize="inherit" />
                    </IconButton>
                    }
                >
                    {this.state.alertMessage}
                </Alert>
            </Collapse>

        )
    }

}

export default AccountForm;
